import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c5610c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer_wrap" }
const _hoisted_2 = { class: "drawer_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drawer_title_txt" }, "中奖名单", -1))
const _hoisted_4 = { class: "drawer_content" }
const _hoisted_5 = { class: "drawer_action_group" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "drawer_list" }
const _hoisted_8 = {
  key: 0,
  id: "scroll",
  style: {"height":"calc(100vh - 220px)","overflow-y":"scroll"}
}
const _hoisted_9 = {
  key: 1,
  style: {"height":"calc(100vh - 220px)","overflow-y":"scroll"}
}
const _hoisted_10 = { class: "fold_top" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "观众名称", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "观众信息", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "drawer_footer" }
const _hoisted_16 = { class: "btn_group" }

import CDelModal, { RootModal } from '@/components/CDelModal.vue';
import { computed, reactive, ref, unref, onMounted } from 'vue';
import { Button, Select, Table, Collapse, message, notification } from 'ant-design-vue';
import http from '@/api';
import router from '@/router';
import { Event, SelList } from './lottery';
import { getCurrentInstance } from 'vue';
import { getToken } from '@/plugins/cookie';
import { emptyDataSec } from '@/assets';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';


export default /*#__PURE__*/_defineComponent({
  __name: 'WinningEvent',
  props: {
    data: null
  },
  emits: ['click:callbackWinPage'],
  setup(__props: any, { emit }) {

const props = __props as {
  data: {
    id: number;
    draw_id: number;
    reward_id: number;
  };
};

const aButton = Button;
const aTable = Table;
const aSelect = Select;
const aCollapse = Collapse;
const aCollapsePanel = Collapse.Panel;
const studioId = router.currentRoute.value.params.studioId;

const onBlack = () => {
  emit('click:callbackWinPage');
};

// 获取活动抽奖中奖名单
const winList = ref<Event[]>([]);
const number = ref();
const screenList = ref<SelList[]>(); //选择器 数组
const scrType = ref(0);
const collapseList = ref<any>([]);
const loading = ref(false);

const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 20, // 每页条数
  totalSize: 0, // 总页数
});

const getWinList = useDebounce(() => {
  loading.value = true;
  const data = {
    studio_id: studioId,
    id: props.data.id,
    draw_id: scrType.value,
    reward_id: 0,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  http.lottery
    .drawResultNew({ params: data })
    .then((res) => {
      number.value = res.data.data.number;
      if (res.data.data.data.data) {
        winList.value.push(...res.data.data.data.data);
      }
      screenList.value = res.data.data.draw || [];
      screenList.value?.unshift({ id: 0, title: '全部' });
      collapseList.value = res.data.data.data || [];

      pageConfig.totalSize = res.data.data.data.total || 0;
      pageConfig.current++;
    })
    .finally(() => (loading.value = false));
});
getWinList();
const onChange = () => {
  winList.value = [];
  pageConfig.current = 1;
  getWinList();
};

//滚动加载数据
const handleScroll = () => {
  //窗口滚要做的操作写这里
  let sh = document.getElementById('scroll')?.scrollHeight || document.body.scrollHeight; // 内容可视区域的高度加上溢出（滚动）的距离
  let st = document.getElementById('scroll')?.scrollTop || document.body.scrollTop; // 滚动条距离顶部的距离
  let ch = document.getElementById('scroll')?.clientHeight || document.body.clientHeight; // 内容可视区域的高度
  // console.log('sh-%s---st-%s----ch-%s', sh, st, ch);
  if (st + ch >= sh - 100) {
    //快到底时----加载
    if (pageConfig.totalSize && winList.value.length < pageConfig.totalSize) {
      getWinList(); // 加载数据的方法
    }
  }
};
// 滚动事件
onMounted(() => {
  //监听页面滚动事件
  document.getElementById('scroll')?.addEventListener('scroll', handleScroll);
});

const columns = [
  {
    title: '奖项名称',
    dataIndex: 'draw_title',
    align: 'left',
    ellipsis: true,
  },
  {
    title: '奖品名称',
    dataIndex: 'reward_title',
    align: 'left',
    ellipsis: true,
  },
  {
    title: '观众名称',
    dataIndex: 'realname',
    align: 'left',
    ellipsis: true,
  },
  {
    title: '观众信息',
    dataIndex: 'mobile',
    align: 'left',
  },
];

const selectedRowKeys = ref<string[]>([]);
selectedRowKeys.value = [];
const onSelectChange = (changableRowKeys: string[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});

// 删除
const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});

const openDelModal = () => {
  delModal.visible = !delModal.visible;
};

const delDrawWin = () => {
  const data = {
    ids: selectedRowKeys.value.join(','),
    studio_id: studioId,
  };
  http.lottery
    .delDrawWin(data)
    .then((res) => {
      message.success(res.data.message);
      openDelModal();
      winList.value = [];
      pageConfig.current = 1;
      getWinList();
      selectedRowKeys.value = [];
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
const selectKeys = ref([{}]);
const onCheckAllChange = (item: any) => {
  selectKeys.value[item.id] = !selectKeys.value[item.id];
  selectedRowKeys.value = getSelectIds.value;
};
const getSelectIds = computed(() => {
  const selectArr = Array<any>();
  Object.keys(selectKeys.value).forEach((e) => {
    if (selectKeys.value[e] === true) {
      selectArr.push(e);
    }
  });
  return selectArr;
});
// 抽奖 名单管理 导出
const { proxy }: any = getCurrentInstance();
const token = getToken();
const corn = ref(1);
const messageTip = ref();
const drawExport = useDebounce((type: number) => {
  const data = {
    studio_id: studioId,
    type: type,
    is_cron_download: corn.value,
    id: props.data.id,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
const itemExport = useDebounce((type: number, item: any) => {
  let created_at = item[0].created_at;
  const data = {
    studio_id: studioId,
    type: type,
    is_cron_download: corn.value,
    id: props.data.id,
    draw_id: scrType.value,
    reward_id: props.data.reward_id,
    created_at: created_at,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_unref(aButton), {
          type: "link",
          class: "drawer_title_back",
          onClick: onBlack
        }, {
          default: _withCtx(() => [
            _createTextVNode("返回>>")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createVNode(_unref(aSelect), {
              value: scrType.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((scrType).value = $event)),
              style: {"width":"120px"},
              onChange: onChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(screenList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: item.id,
                    value: item.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"]),
            _createVNode(_unref(aButton), {
              class: "drawer_action_btn",
              disabled: selectedRowKeys.value.length === 0,
              onClick: openDelModal
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("span", _hoisted_6, "已中奖: " + _toDisplayString(number.value) + "人", 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (scrType.value === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_unref(aTable), {
                  columns: columns,
                  "data-source": winList.value,
                  "row-selection": _unref(rowSelection),
                  pagination: false,
                  loading: loading.value,
                  rowKey:  (res) => {
              return res.id;
          }
                }, null, 8, ["data-source", "row-selection", "loading", "rowKey"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_unref(aCollapse), { expandIconPosition: "right" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collapseList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_unref(aCollapsePanel), { key: index }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("p", null, "第" + _toDisplayString(index + 1) + " 轮", 1),
                            _hoisted_11,
                            _hoisted_12,
                            _createElementVNode("p", {
                              style: {"color":"#1890ff"},
                              onClick: ($event: any) => (_unref(itemExport)(23, item))
                            }, "导出", 8, _hoisted_13)
                          ])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (i, j) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: j,
                              class: "fold_con"
                            }, [
                              _createVNode(_component_a_checkbox, {
                                checked: i.flag,
                                "onUpdate:checked": ($event: any) => ((i.flag) = $event),
                                onChange: ($event: any) => (onCheckAllChange(i))
                              }, null, 8, ["checked", "onUpdate:checked", "onChange"]),
                              _createElementVNode("p", null, _toDisplayString(i.realname), 1),
                              _createElementVNode("p", null, _toDisplayString(i.mobile), 1)
                            ]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                (collapseList.value.length === 0)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(emptyDataSec),
                      class: "null_img"
                    }, null, 8, _hoisted_14))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_unref(aButton), {
            class: "mod_modal_btn",
            onClick: onBlack
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_unref(aButton), {
            class: "mod_modal_btn mod_type_primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(drawExport)(23)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出记录")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(CDelModal, {
      visible: delModal.visible,
      centered: "",
      ok: delDrawWin,
      close: openDelModal
    }, null, 8, ["visible"])
  ], 64))
}
}

})